import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../context/LangContext";
import { useGoPage } from "../../hooks/useGoPage";

import "./style.css"

function Delivery() {
    const goPage = useGoPage();
    const { translations } = useContext(LangContext);
    const [tarifs, setTarifs] = useState([]);
    const [updt, setUpdt] = useState([]);

    useEffect(() => {
        const fetchTarif = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/converters/get`);
            const res = await req.json();

            if (req.status !== 200) alert(res.message);
            setTarifs(res);
        }
        fetchTarif();
    }, [])

    const setValue = (e, idx, rowId, field) => {
        let newValue = e.target.value;
        let newTarifs = [...tarifs];

        if (field === 'weight') {
            newValue = newValue.replace(/[^0-9]/g, '');
            newValue = newValue.replace(/^0+(?=\d)/, '');
        }
        if (field === 'price') {
            newValue = newValue.replace(/[^0-9.]/g, '');
            newValue = newValue.replace(/^0+(?!\.|$)/, '');
            if (newValue !== '' && !/^[0-9]+(\.[0-9]{0,2})?$/.test(newValue)) return;
        }

        newTarifs[idx].converter[rowId][field] = newValue;
        setTarifs(newTarifs);

        if (!updt.includes(idx)) setUpdt([...updt, idx]);
    }

    const addRow = (idx) => {
        let newTarifs = [...tarifs];
        newTarifs[idx].converter.push({ weight: '', price: '' });

        setTarifs(newTarifs);
    }

    const updateTarif = async () => {
        let newTarifs = [...tarifs];

        for (let idx of updt) {
            console.log(tarifs[idx]);

            const req = await fetch(`${process.env.REACT_APP_API_URL}/converters/edit`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}`
                },
                body: JSON.stringify(tarifs[idx])
            });
            const res = await req.json();

            if (req.status !== 200) {
                alert('Erreur lors de la mise à jour de ' + tarifs[idx].name + ' : ' + res.message);
                continue
            }
            newTarifs[idx] = res;
        }
        setTarifs(newTarifs);
        alert('Les tarifs on bien été mis à jour.')
    }


    return (
        <div className='page page_delivery'>
            <button
                className="btn_return"
                onClick={() => goPage('orders')}
            >
                {'<'}-<span>{translations.return}</span>--
            </button>

            <p className='title_page'>
                - <span>Tarifs de livraison</span> -
            </p>

            {tarifs && tarifs.length !== 0 &&
                <div className="tables">
                    {tarifs.map((table, idx) =>
                        <div key={idx} className="table_tarif">
                            <p className="title_table">{table.name}</p>

                            <div className="th">
                                <p>poids (g) jusqu'à</p>
                                <p>tarif en €</p>
                            </div>

                            {table.converter.length !== 0 && table.converter.map((row, id) =>
                                <div className="row" key={idx + '-' + id}>
                                    <input
                                        type="text"
                                        placeholder="500"
                                        inputMode="numeric"

                                        value={row.weight}
                                        onChange={(e) => setValue(e, idx, id, 'weight')}
                                    />
                                    <input
                                        type="text"
                                        placeholder="10.00"
                                        inputMode="numeric"

                                        value={row.price}
                                        onChange={(e) => setValue(e, idx, id, 'price')}
                                    />
                                </div>
                            )}

                            <button
                                className="btn_add_row"
                                onClick={() => addRow(idx)}
                            >+ Ajouter une ligne</button>
                        </div>
                    )}
                </div>
            }

            <div className="panel_form">
                <button
                    className="btn_submit"
                    onClick={() => updateTarif()}
                >Mettre à jour</button>
            </div>
        </div>
    )
}

export default Delivery;